// Common helpers and simple caches
export const sleep = (ms) => new Promise((res) => setTimeout(res, ms));

export const withTimeout = (promise, timeoutMs = 10000, message = 'Timeout') =>
  Promise.race([
    promise,
    new Promise((_, reject) => setTimeout(() => reject(new Error(message)), timeoutMs)),
  ]);

// Generic in-memory cache
const mem = new Map();
export function getCache(key) {
  return mem.get(key);
}
export function setCache(key, value) {
  mem.set(key, value);
}
